import { CLOSING_DOCUMENT_SUMMARY_CUSTOM_TYPE } from "constants/chatType";
import { useToast } from "hooks/useToast";

import { useAddSummaryToDocumentChannelMutation } from "store/apis/financialClosing";
import { BackendError } from "types/utils/error";
import { RadianButton } from "components/DesignSystem/RadianButton/RadianButton";
import { FinancialReviewFile } from "./FinancialReviewModal";
import AIGenerateStar from "static/images/AIGenerateStar.svg";

export const FinancialReviewAISummary = ({
  currentFile,
  entityId,
  channelId,
  parentMessageId,
  setShowChannel,
  summary,
}: {
  currentFile: FinancialReviewFile;
  entityId: string;
  channelId: string;
  parentMessageId: string;
  setShowChannel: (show: boolean) => void;
  summary: string;
}) => {
  const { alertToast } = useToast();
  const [addSummaryToDocument] = useAddSummaryToDocumentChannelMutation();

  const handleAddSummary = async () => {
    if (!parentMessageId || !channelId) return;

    if (currentFile.isClosingDocument && currentFile.summary_sent_to_chat) {
      setShowChannel(true);
      return;
    }

    try {
      await addSummaryToDocument({
        entityId,
        channelUrl: channelId,
        text: summary,
        parentMessageId: parentMessageId,
        customType: CLOSING_DOCUMENT_SUMMARY_CUSTOM_TYPE,
        metadata: {
          summary_document_id: currentFile.file_data?.uuid ?? "",
        },
      }).unwrap();
      setShowChannel(true);
    } catch (error) {
      alertToast(
        {
          message: (error as BackendError).data?.error?.message,
        },
        error as Error
      );
    }
  };

  return (
    <div className="t-bg-[linear-gradient(90deg,_#f7f4ff,_#ffffff)]  t-p-4 t-flex t-flex-col t-gap-3 t-relative">
      <div className="t-absolute t-left-0 t-top-0 t-bottom-0 t-w-0.5 t-bg-[linear-gradient(180deg,_#FB6FD5,_#C65DE7,_#8A4ED4)]"></div>
      <div className="t-text-subtext t-text-text-100 t-flex t-items-center t-gap-2">
        <img src={AIGenerateStar} alt="AIGenerateStar" />
        <span className="t-text-subtext t-text-text-60 t-w-fit">
          AI Summary
        </span>
      </div>
      <div className="t-text-body-italic t-italic">{summary}</div>
      <div className="t-flex t-items-center t-gap-3">
        <span className="t-text-button-sm t-text-text-30">
          Have any questions?
        </span>
        <RadianButton onClick={handleAddSummary} iconSize="t-size-4">
          Ask AI Agent
        </RadianButton>
      </div>
    </div>
  );
};
